import * as corgi from 'external/dev_april_corgi+/js/corgi';
import {CHANGED} from 'external/dev_april_corgi+/js/emu/events';

import {Node} from './execution/graph';
import {NODE_SPECS} from './nodes/nodes';
import {
  AMBER_600_RGBA,
  BLUE_600_RGBA,
  CYAN_600_RGBA,
  EMERALD_600_RGBA,
  FUCHSIA_600_RGBA,
  GREEN_600_RGBA,
  LIME_600_RGBA,
  ORANGE_600_RGBA,
  PINK_600_RGBA,
  RED_600_RGBA,
  SKY_600_RGBA,
  VIOLET_600_RGBA,
  YELLOW_600_RGBA,
} from './types/colors';

import {State, NodeEditorController} from './node_editor_controller';
import {Input} from './widgets';

export function makeNodeEditor({
  node,
  onUpdate,
}: {
  node: Node;
  onUpdate: (node: Node) => void;
}) {
  return <NodeEditor node={node} onUpdate={onUpdate} />;
}

export function NodeEditor(
  {
    node,
    onUpdate,
  }: {
    node: Node;
    onUpdate: (node: Node) => void;
  },
  state: State | undefined,
  updateState: (newState: State) => void,
) {
  if (!state) {
    state = {};
  }

  return (
    <>
      <div
        js={corgi.bind({
          controller: NodeEditorController,
          args: {node, onUpdate},
          state: [state, updateState],
        })}
        className="bg-neutral-800 max-h-[inherit] oy-4 overflow-y-auto p-4 text-sm rounded"
      >
        <div>
          {NODE_SPECS.filter(
            s => node.behavior.kind === 'js' && node.behavior.id === s.id,
          )
            .map(s => s.label)
            .join('') || node.label}
        </div>
        <table>
          <tbody>
            <tr>
              <td className="pe-2">Label:</td>
              <td>
                <Input
                  unboundEvents={{corgi: [[CHANGED, 'rename']]}}
                  value={node.label}
                />
              </td>
            </tr>
            <tr>
              <td className="pe-2 pt-4">Color:</td>
              <td className="pt-4">
                <div className="flex gap-2 leading-[0]">
                  {(
                    [
                      [RED_600_RGBA, 'red'],
                      [ORANGE_600_RGBA, 'orange'],
                      [AMBER_600_RGBA, 'amber'],
                      [YELLOW_600_RGBA, 'yellow'],
                      [LIME_600_RGBA, 'lime'],
                      [GREEN_600_RGBA, 'green'],
                      [EMERALD_600_RGBA, 'emerald'],
                      [CYAN_600_RGBA, 'cyan'],
                      [SKY_600_RGBA, 'sky'],
                      [BLUE_600_RGBA, 'blue'],
                      [VIOLET_600_RGBA, 'violet'],
                      [FUCHSIA_600_RGBA, 'fuchsia'],
                      [PINK_600_RGBA, 'pink'],
                    ] as const
                  ).map(([color, label]) => (
                    <label>
                      <input
                        checked={node.color === color}
                        className={
                          'appearance-none h-4 rounded w-4 checked:outline checked:outline-gray-50'
                        }
                        name="color"
                        style={`background: #${color.toString(16).padStart(8, '0')}`}
                        title={label}
                        type="radio"
                        unboundEvents={{change: 'recolor'}}
                        value={String(color)}
                      />
                    </label>
                  ))}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
